const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7029/api/',
    //Live
    apiUrl: 'https://pt-api.off-ease.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;
